export enum MapTooltipLevelType {
  REGULAR = 'REGULAR',
  UNKNOWN = 'UNKNOWN'
}

export type MapTooltipSkuLevel = {
    order: number,
    name: string,
    groundGroup?: string,
    skus: {sku: string, quantity: number}[],
    palletQty: number,
    type: MapTooltipLevelType
}

export type MapTooltipPalletLevel = {
  order: number,
  name: string,
  groundGroup?: string,
  pallets: {
    name: string,
    products: {sku: string, quantity: number}[]
  }[],
  palletQty: number,
  type: MapTooltipLevelType
}
export type MapTooltipLevel = MapTooltipSkuLevel | MapTooltipPalletLevel;


export type MapTooltipContent = {
    levels: MapTooltipLevel[],
    empty: boolean,
    isPigeonhole?: boolean;
}

export type PigeonholeTooltipContent = {
  pallets: {
    products: { sku: string, quantity: number }[],
    skuQty: number
  }[],
  palletQty: number,
  empty: boolean,
  groundGroup?: string
}
